import React from 'react';
import classNames from 'classnames';
import PlainButton from '../PlainButton';

const ns = `nav-control`;

/**
 * Displays a label and controls the visibility of it's respective menu.
 */
const NavControl = ({
	active, label, onMouseEnter, onMouseLeave, onClick, setMenuItemRef,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		active,
	});

	return (
		<div
			ref={setMenuItemRef}
			className={`${ rootClassnames } text-large`}
		>
			<PlainButton
				onClick={onClick}
				onMouseEnter={() => {
					(typeof onMouseEnter === 'function' && onMouseEnter());
				}}
				onMouseLeave={() => {
					(typeof onMouseLeave === 'function' && onMouseLeave());
				}}
			>
				{label}
			</PlainButton>
		</div>
	);
};

export default NavControl;
